import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { IArticle } from '../../types/api/homeApi';
import { NoData } from '../common/NoData';
import { formatDateToDDMMYYYY } from '../../utils/hepler';
import { useTranslation } from 'react-i18next';
import { IBlog, ISubBlog } from '../../types/features/multiLanguageSlice';

const Blogs: React.FC<{ articles: Array<IArticle> }> = ({ articles }) => {
    const {t} = useTranslation()

const blog_json = t('blog.blogs', { returnObjects: true })  as ISubBlog[];
console.log(blog_json,'blog_json');

    return (
        <section className='blogs inner-padding'>
            <div className='container'>
                <div className='blog-title'>
                    <div>
                        <h3 className='title-highlight'>{t('home.blog.title')}</h3>
                        <h2 className='title'>{t('home.blog.description')}</h2>
                    </div>
                    <div>
                        <Link to="/blogs" className='btn btn-gold' type='button'>{t('home.blog.view_all')}</Link>
                    </div>
                </div>
                <Row>

                    {articles && articles.length > 0 ?
                        articles.map((article: IArticle, index: number) => (
                            < Col md={6} sm={6} lg={4} key={"article_" + index}>
                                <div className='blog-box'>
                                    <div className='blog-image'>
                                        <img src={require('../../assets/images/blog-01.jpg')} alt='demo' />
                                    </div>
                                    <div className='blog-info'>
                                        <ul>
                                            <li>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                {formatDateToDDMMYYYY(article.updated_at)}
                                            </li>
                                            <li>
                                                <i className="fa fa-map-marker" aria-hidden="true"></i>
                                                {blog_json && blog_json.length > 0 && blog_json[index].location_name}
                                            </li>
                                        </ul>
                                    <h4>{blog_json && blog_json.length > 0 && blog_json[index].title}</h4>
                                        <Link to={'/blogs/' + article.slug} className='btn btn-text'>{t('home.about_us.read_more') }<i className="fa fa-long-arrow-right" aria-hidden="true"></i></Link>
                                    </div>
                                </div>
                            </Col>
                        ))
                        : <NoData message='Oops!! No Articles Found.' />}
                </Row>
            </div>
        </section >
    )
}

export default Blogs